module.exports = __webpack_public_path__ + "static/media/fly0157.f41362aa.webp";